import { ITransactionFormState } from "../../components/Transactions/Components/Form/TransactionForm";
import { TransactionFormField } from "../../components/Transactions/Components/Form/config/config";
import { AutomationType, CategoryAutomationAction, IAutomation, IAutomationExecutionResult, PaymentMethodAutomationAction } from "../../config/automation";
import { setBudgetCallback } from "./categories";
import { shareWithFriendsFixedCallback, shareWithFriendsPercentageCallback } from "./payment_methods";

export const findAutomations = (field: keyof ITransactionFormState, value: any) => (automation: IAutomation): boolean => {
    return (
        !!value && (
               (field === 'paymentMethodId' && automation.type === AutomationType.PAYMENT_METHOD && value === automation.value.paymentMethodId)
            || (field === 'categoryId' && automation.type === AutomationType.CATEGORY && value === automation.value.categoryId)
        )
    );
};

export const executeAutomation = (automation: IAutomation): IAutomationExecutionResult | undefined => {
    switch(automation.value.action) {
        case PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED:
            return shareWithFriendsFixedCallback(automation.value.payload);
        case PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE:
            return shareWithFriendsPercentageCallback(automation.value.payload);
        case CategoryAutomationAction.SET_BUDGET:
            return setBudgetCallback(automation.value.payload);
    }
};

export const toForm = (results: (IAutomationExecutionResult | undefined)[]): ITransactionFormState | {} => {
    const result = {} as ITransactionFormState;

    results = results.filter(item => item);
    if (!results) {
        return result;
    }

    const shareWithFriends = results.filter(item => item?.fieldKey === TransactionFormField.AMOUNT_SHARING);
    if (!!shareWithFriends.length) {
        results = results.filter(item => item?.fieldKey !== TransactionFormField.AMOUNT_SHARING);

        result.splits = shareWithFriends.map(item => item?.data);
    }

    const setBudget = results.filter(item => item?.fieldKey === TransactionFormField.BUDGET);
    if (!!setBudget.length) {
        results = results.filter(item => item?.fieldKey !== TransactionFormField.BUDGET);

        result.budgetId = setBudget[0]?.data;
    }

    results.forEach(item => {
        (result[item!.field] as any) = item?.data;
    });

    return result;
};
